import Vue from 'vue';
import Router from 'vue-router';
// import routeadmin from './routers'
import routes from './routers_caiji';
import store from '@/store';
import iView from 'iview';
import {
  setToken,
  // getToken,
  canTurnTo
  // setTitle
} from '@/libs/util';
import config from '@/config';
const { homeName } = config;

Vue.use(Router);
const router = new Router({
  routes,
  mode: ''
});
const LOGIN_PAGE_NAME = 'login';

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next();
  // 有权限，可访问
  else {
    next({
      replace: true,
      name: 'error_401'
    });
  } // 无权限，重定向到401页面
};
// const myroute = [{
//   path: 'doc',
//   name: 'doc',
//   meta: {
//     title: '文档',
//     href: 'https://lison16.github.io/iview-admin-doc/#/',
//     icon: 'ios-book'
//   }
// }];
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();

  // const token =  localStorage.getItem('token') || '';
  const token = store.state.user.token;

  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    });
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next(); // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    });
  } else {
    console.log('这是要我从路由守卫这里走呀', token);
    // if (token) {
    //   next();
    // } else {
    //   next({
    //     name: 'login'
    //   })
    // }

    if (store.state.user.hasGetInfo) {
      // if (Number(store.state.user.lv) === 9) {
      //   router.options.routes = myroute;
      //   router.addRoutes(myroute);
      // }
      turnTo(to, store.state.user.lv, next);
    } else {
      store
        .dispatch('getUserInfo')
        .then(user => {
          // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
          turnTo(to, user.data.lv, next);
        })
        .catch(() => {
          setToken('');
          next({
            name: 'login'
          });
        });
    }
  }
});

router.afterEach(to => {
  // setTitle(to, router.app)
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router;
